<template>
  <div class="terms-container pt-0 col-12  mx-auto">
    <div class="terms" v-html="terms"></div>
  </div>
</template>

<script>

export default {
  name: 'RegisterTerms',
  computed: {
    terms () {
      return this.$store.getters.terms
    }
  }
}
</script>
